// ######################### VERIFIEDEMAIL REAL TIME VERIFICATION WIDGET #########################

const VERIFY_INSTANCE = "verifiedEmail";
const VERIFY_SETTINGS_VAR = "_verifiedEmailSettings";
const DOCUMENTATION_LINK = process.env.WIDGET_HELP_URL;
const VERIFY_DEBUG = process.env.WIDGET_IS_DEBUG;
const VERIFY_INPUT_CHANGE_TIMEOUT = 1200;

const _VE_INITIALIZE_EVENT = "ve.initialize";
const _VE_EVENTS = {
    onBeforeValidation: "ve.before.validation",
    onLocalValidation: "ve.local.validation",
    onRequest: "ve.request",
    onResponse: "ve.response",
    onSuccess: "ve.success"
};

const INVALID_SELECTOR = "INVALID_SELECTOR";
const INVALID_EMAIL = "INVALID_EMAIL";
const TIMEOUT_ERROR = "TIMEOUT_ERROR";
const INSTANCE_ERROR = "INSTANCE_ERROR";
const FAILED_ERROR = "FAILED_ERROR";

const VERIFY_ERRORS = {
    INVALID_SELECTOR: "Input not found",
    INVALID_EMAIL: "Email address is not valid",
    INVALID_FORMAT: "Invalid email address format",
    TIMEOUT_ERROR: "Verification request time out",
    FAILED_ERROR: "Verification request failed",
    INSTANCE_ERROR: "Invalid instance ID"
};

const VERIFY_DEFAULT_MESSAGES = {
    pending: "Verifying",
    malformed: "Invalid email address format",
    ghost: "Domain name does not exist or does not have email servers",
    unknown: "Unable to connect to email server",
    nonexistent: "Email address does not exist",
    failed: "Messages cannot be delivered to the email address",
    full: "Mailbox is full",
    catchall: "Domain accepts mail for any mailbox",
    deliverable: "Email address is valid"
};

const VERIFY_DEFAULT_VALID_STATUS = ["deliverable", "full"];

const successCheckSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_2_5)">
    <path d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z" fill="#2DB674"/>
    <path d="M10.4 17.2999C10.1 17.2999 9.79999 17.1999 9.69999 16.9999L6.79999 13.6999C6.39999 13.2999 6.49999 12.6999 6.89999 12.2999C7.29999 11.8999 7.89999 11.9999 8.29999 12.3999L10.5 14.8999L16.8 8.6999C17.2 8.2999 17.8 8.2999 18.2 8.6999C18.6 9.0999 18.6 9.6999 18.2 10.0999L11.1 16.9999C10.9 17.1999 10.6 17.2999 10.4 17.2999Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_2_5">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>
`;

const failedCheckSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_2_9)">
    <path d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z" fill="#F26868"/>
    <path d="M13.42 12L16.65 8.77004C16.7547 8.6804 16.8397 8.57008 16.8997 8.44601C16.9597 8.32195 16.9935 8.18681 16.9988 8.0491C17.0041 7.91138 16.9809 7.77404 16.9306 7.64572C16.8803 7.51739 16.8041 7.40085 16.7066 7.30339C16.6092 7.20594 16.4926 7.12968 16.3643 7.0794C16.236 7.02913 16.0986 7.00592 15.9609 7.01124C15.8232 7.01656 15.6881 7.05029 15.564 7.11032C15.4399 7.17034 15.3296 7.25536 15.24 7.36004L12 10.59L8.76998 7.36004C8.68033 7.25536 8.57002 7.17034 8.44595 7.11032C8.32189 7.05029 8.18675 7.01656 8.04903 7.01124C7.91131 7.00592 7.77398 7.02913 7.64566 7.0794C7.51733 7.12968 7.40079 7.20594 7.30333 7.30339C7.20588 7.40085 7.12962 7.51739 7.07934 7.64572C7.02907 7.77404 7.00586 7.91138 7.01118 8.0491C7.0165 8.18681 7.05023 8.32195 7.11026 8.44601C7.17028 8.57008 7.2553 8.6804 7.35998 8.77004L10.59 12L7.35998 15.23C7.2553 15.3197 7.17028 15.43 7.11026 15.5541C7.05023 15.6781 7.0165 15.8133 7.01118 15.951C7.00586 16.0887 7.02907 16.226 7.07934 16.3544C7.12962 16.4827 7.20588 16.5992 7.30333 16.6967C7.40079 16.7941 7.51733 16.8704 7.64566 16.9207C7.77398 16.971 7.91131 16.9942 8.04903 16.9888C8.18675 16.9835 8.32189 16.9498 8.44595 16.8898C8.57002 16.8297 8.68033 16.7447 8.76998 16.64L12 13.42L15.23 16.65C15.4213 16.8139 15.6674 16.8995 15.919 16.8898C16.1707 16.88 16.4094 16.7757 16.5875 16.5976C16.7656 16.4195 16.87 16.1808 16.8797 15.9291C16.8894 15.6774 16.8038 15.4313 16.64 15.24L13.42 12Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_2_9">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>
`;

/**
 * Main widget function
 *
 * @returns {boolean}
 * @constructor
 */
function VerifiedEmail(token, recaptchaSiteKey = "") {
    this.token = token;
    if (VERIFY_DEBUG) console.debug(`[VerifiedEmail] Token`, this.token);

    this.endPoint = process.env.WIDGET_V1_API_URL;
    if (VERIFY_DEBUG) console.debug(`[VerifiedEmail] API Endpoint`, this.endPoint);

    this.helpers = new (function () {
        this.validate = (email) => {
            return String(email)
                .toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
        };
        this.error = (msg, doc = true) => {
            console.error(`[VerifiedEmail] ${VERIFY_ERRORS[msg]}. ${doc ? `See our documentation ${DOCUMENTATION_LINK}` : ""}`);
            return false;
        };
        this.isValidateObject = (obj, email) => {
            if (typeof obj !== "object") {
                if (VERIFY_DEBUG) console.debug("[VerifiedEmail] Received invalid or empty object from server", obj);
                return null;
            }
            if (VERIFY_DEBUG) console.debug("[VerifiedEmail] Received json object from server", obj);
            return typeof obj.email === "string" && typeof obj.result === "string" && obj.email === email ? obj : null;
        };
        this.generateID = () => {
            const length = 5;
            let result = "";
            const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            const charactersLength = characters.length;
            let counter = 0;
            while (counter < length) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
                counter += 1;
            }
            return result;
        };
        this.uuid = () =>
            "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
                const r = (Math.random() * 16) | 0,
                    v = c == "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
    })();

    this.instances = [];
    window[VERIFY_INSTANCE] = this;

    this.initialize = (selectorOrField, config = null) => {
        const instanceId = this.helpers.uuid();
        this.instances[instanceId] = new this.instance(this, instanceId, selectorOrField, config);
        return instanceId;
    };

    this.instance = function (widget, instanceId, selectorOrField, config = null) {
        this.widget = widget;
        this.instanceId = instanceId;
        this.selector = typeof selectorOrField == "string" ? selectorOrField : null;
        this.field = typeof selectorOrField != "string" ? selectorOrField : null;
        this.config = config || {};
        this.config.live = !!this.config.live;
        this.config.submit = !!this.config.submit;
        this.config.timeout = this.config.timeout || 30;
        this.config.debounceDelay = this.config.debounceDelay || VERIFY_INPUT_CHANGE_TIMEOUT;
        this.config.messages = Object.assign({}, VERIFY_DEFAULT_MESSAGES, this.config.messages);
        this.config.validStatuses = this.config.valid || VERIFY_DEFAULT_VALID_STATUS;
        this.config.callbacks = this.config.callbacks || {};

        if (typeof grecaptcha === "undefined" && recaptchaSiteKey) {
            const script = document.createElement("script");
            script.src = `https://www.google.com/recaptcha/enterprise.js?render=${recaptchaSiteKey}`;
            document.head.appendChild(script);
        }
        // Validate field selector
        if (
            !this.field &&
            (this.selector || "") !== "" &&
            (document.querySelectorAll(this.selector || "").length === 0 ||
                ((document.querySelector(this.selector || "") || {}).tagName || "") !== "INPUT")
        )
            return this.helpers.error(INVALID_SELECTOR);

        this.field = !this.field ? document.querySelector(this.selector) : this.field;

        if (this.field === null) {
            this.field = document;
        } else {
            this.field.setAttribute("data-instance", this.instanceId);

            Object.keys(VERIFY_DEFAULT_MESSAGES).map((emailStatus) => {
                if ((this.field.getAttribute(`verify-${emailStatus}`) || "") !== "")
                    this.config.messages[emailStatus] = this.field.getAttribute(`verify-${emailStatus}`);
            });
        }

        Object.keys(_VE_EVENTS).map((callbackName) => {
            if (typeof this.config.callbacks[callbackName] == "function")
                this.field.addEventListener(_VE_EVENTS[callbackName], this.config.callbacks[callbackName]);
        });

        if (VERIFY_DEBUG) console.debug(`[VerifiedEmail] New instance created`, this.instanceId, this.field, this.config);

        this.InputController = function (e, callback, callbackEmpty, delay) {
            this.e = e;
            this.timer = null;

            this.onChange = (email) => {
                if (this.timer) clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    if ((email || "") !== "") callback(email);
                    else callbackEmpty();
                }, delay);
            };

            this.e.addEventListener("keyup", (event) => this.onChange(event.currentTarget.value));
            this.e.addEventListener("change", (event) => this.onChange(event.currentTarget.value));
        };
        this.controller = this.config.live
            ? new this.InputController(
                  this.field,
                  (email) => {
                      if (this.resultWrapper) this.resultWrapper.classList.remove("active");
                      this.widget.verify(email, this.instanceId).then((verifyObj) => {
                          let status = (verifyObj || {}).result;
                          if (!status) status = this.widget.helpers.validate(email) ? "nonexistent" : "malformed";
                          this.render((this.config.messages || {})[status] || VERIFY_DEFAULT_MESSAGES[status], status);
                      });
                  },
                  () => this.render(),
                  this.config.debounceDelay
              )
            : null;

        this.resultWrapper = null;
        this.preRender = () => {
            this.resultWrapper = document.createElement("span");
            this.resultWrapper.classList.add(`verifiedemail`);
            this.field.parentNode.insertBefore(this.resultWrapper, this.field.nextSibling);
            this.resultWrapper.appendChild(this.field);
            this.resultIcon = document.createElement("span");
            this.resultIcon.classList.add("verifiedEmailIcon");
            this.resultWrapper.appendChild(this.resultIcon);

            this.resultText = document.createElement("span");
            this.resultText.classList.add("verifiedEmailResult");
            this.resultWrapper.appendChild(this.resultText);

            const styles = document.createElement("style");
            styles.innerHTML = `
 .verifiedemail {
    position: relative;
    display: block;  
    height: ${this.field.getClientRects()[0].height}px;
    width: ${this.field.getClientRects()[0].width}px;
    border-radius: ${window.getComputedStyle(this.field).borderRadius};  
 }
 
 .verifiedemail input,.verifiedemail input:focus-within,.verifiedemail input:focus{
    outline: none;
    box-shadow:none;
    border: 1px solid ${window.getComputedStyle(this.field).borderColor};
 }
 
 .verifiedemail.is-valid input,.verifiedemail.is-valid input:focus-within,.verifiedemail.is-valid input:focus{
 border: 1px solid #2DB674;
 }
 .verifiedemail.is-failed input,.verifiedemail.is-failed input:focus-within,.verifiedemail.is-failed input:focus{
 border: 1px solid #F26868;
 }
 .verifiedemail.active .verifiedEmailIcon.active,.verifiedemail.active .verifiedEmailResult{
    opacity: 1;
    visibility: visible;    
 } 
 
 .verifiedemail .verifiedEmailIcon {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 32px;  
    display: flex;
    align-items:center;
    justify-content:center; 
    opacity: 0;
    visibility: hidden;
    transition: .3s ease-out;    
 }
 
  .verifiedemail .verifiedEmailResult {
    position: absolute;
    right: 7px;
    top: calc(100% + 5px);
    font-size: 11px;
    display: flex;
    align-items:center;
    justify-content:center; 
    opacity: 0;
    visibility: hidden;
    transition: .3s ease-out;    
 }

             
        `;
            document.querySelector("head").appendChild(styles);
        };

        this.svg = "";
        this.svgTimer = null;

        this.render = (msg = null, status = null) => {
            const isValid = this.config.validStatuses.indexOf(status) !== -1;
            this.svg = isValid ? successCheckSvg : failedCheckSvg;
            this.resultIcon.classList.remove("active");
            if (this.svgTimer) clearTimeout(this.svgTimer);
            this.svgTimer = setTimeout(() => {
                this.resultIcon.innerHTML = this.svg;
                this.resultIcon.classList.add("active");
            }, 100);
            this.resultText.innerHTML = msg;
            this.resultWrapper.classList.remove("is-valid");
            this.resultWrapper.classList.remove("is-failed");
            this.resultWrapper.classList.add("active");
            this.resultWrapper.classList.add(isValid ? "is-valid" : "is-failed");
        };

        if (this.config.live) this.preRender();

        this.setSubmit = (e) => {
            if (!e) return;

            if (e.tagName === "FORM") {
                e.addEventListener("submit", (e) => {
                    if (!this.field.classList.contains("is-valid")) {
                        e.preventDefault();
                        this.widget.verify(this.field.value, this.instanceId).then((verifyObj) => {
                            const status = (verifyObj || {}).result || "unknown";
                            if (this.config.validStatuses.indexOf(status) !== -1) {
                                this.field.classList.add("is-valid");
                                e.target.submit();
                            } else {
                                const status = (verifyObj || {}).result || "unknown";
                                if (!this.resultWrapper) {
                                    this.preRender();
                                    setTimeout(() => {
                                        this.render((this.config.messages || {})[status] || VERIFY_DEFAULT_MESSAGES[status], status);
                                    }, 300);
                                } else this.render((this.config.messages || {})[status] || VERIFY_DEFAULT_MESSAGES[status], status);
                            }
                        });
                    }
                });
                if (VERIFY_DEBUG) console.debug("[VerifiedEmail] Submit event", { form: e, instanceId });
                return;
            }
            this.setSubmit(e.parentElement);
        };

        if (this.config.submit) this.setSubmit(this.field.parentElement);
    };

    this.callbacks = {};
    this.on = (event, callback) => {
        this.callbacks[event] = callback;
    };

    this.hookMap = {
        onBeforeValidation: (email, instanceId = null) =>
            new Promise((r) => {
                const event = _VE_EVENTS["onBeforeValidation"];
                const detail = { email, instanceId };
                if (instanceId) this.instances[instanceId].field.dispatchEvent(new CustomEvent(event, { detail, target: this.field }));
                else if (typeof this.callbacks[event] == "function") this.callbacks[event](detail);
                return r();
            }),
        onLocalValidation: (email, isValid = false, instanceId = null) =>
            new Promise((r) => {
                const event = _VE_EVENTS["onLocalValidation"];
                const detail = { email, isValid, instanceId };
                if (instanceId) this.instances[instanceId].field.dispatchEvent(new CustomEvent(event, { detail, target: this.field }));
                else if (typeof this.callbacks[event] == "function") this.callbacks[event](detail);
                return r();
            }),
        onRequest: (email, instanceId = null) =>
            new Promise((r) => {
                const event = _VE_EVENTS["onRequest"];
                const detail = { email, instanceId };
                if (instanceId) this.instances[instanceId].field.dispatchEvent(new CustomEvent(event, { detail, target: this.field }));
                else if (typeof this.callbacks[event] == "function") this.callbacks[event](detail);
                return r();
            }),
        onResponse: (verifyObject, instanceId = null) =>
            new Promise((r) => {
                const event = _VE_EVENTS["onResponse"];
                const detail = { verifyObject, instanceId };
                if (instanceId) this.instances[instanceId].field.dispatchEvent(new CustomEvent(event, { detail, target: this.field }));
                else if (typeof this.callbacks[event] == "function") this.callbacks[event](detail);
                return r();
            }),
        onSuccess: (verifyObject, instanceId = null) =>
            new Promise((r) => {
                const event = _VE_EVENTS["onSuccess"];
                const detail = { verifyObject, instanceId };
                if (instanceId) this.instances[instanceId].field.dispatchEvent(new CustomEvent(event, { detail, target: this.field }));
                else if (typeof this.callbacks[event] == "function") this.callbacks[event](detail);
                return r();
            })
    };

    this.API = function (email, recaptchaToken, e, instanceId = null, callback = (e) => {}) {
        this.e = e;
        this.instanceId = instanceId;

        this.verifyEndPoint = `${this.e.endPoint}`;
        this.verifyEndPointMethod = `POST`;

        this.header = () => ({
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${this.e.token}`
        });

        this.requestTimer = null;

        this.call = (email) => {
            return new Promise((resolveRequest) => {
                this.e.hookMap.onRequest(email, this.instanceId).then(() => {
                    this.requestTimer = setTimeout(
                        () => {
                            this.e.helpers.error(TIMEOUT_ERROR, false);
                            resolveRequest({
                                status: "unknown"
                            });
                        },
                        (this.e.instances[instanceId]?.config?.timeout || 30) * 1000
                    );

                    if (VERIFY_DEBUG) console.debug("[VerifiedEmail] Request", this.verifyEndPoint);

                    fetch(this.verifyEndPoint, {
                        method: this.verifyEndPointMethod,
                        headers: this.header(),
                        body: JSON.stringify({ email, recaptchaToken })
                    })
                        .then((s) => {
                            clearTimeout(this.requestTimer);
                            try {
                                return s.json();
                            } catch (e) {
                                resolveRequest(null);
                            }
                        })
                        .then((json) =>
                            resolveRequest(
                                this.e.helpers.isValidateObject(
                                    typeof json.verifications == "object" && typeof json.verifications.map == "function"
                                        ? json.verifications.find((s) => s.email.toLowerCase() === email.toLowerCase())
                                        : json,
                                    email
                                )
                            )
                        );
                });
            });
        };

        this.call(email).then((vObj) => callback(vObj));
    };

    this.validate = (email, instanceId = null) =>
        new Promise((r) => {
            this.hookMap.onBeforeValidation(email, instanceId).then(() => {
                const status = !!this.helpers.validate(email);
                this.hookMap.onLocalValidation(email, status, instanceId).then(() => r(status));
            });
        });

    this.verify = (email = null, instanceId = null) => {
        return new Promise((resolve, reject) => {
            if (instanceId && typeof this.instances[instanceId] == "undefined") {
                this.helpers.error(INSTANCE_ERROR, false);
                reject(VERIFY_ERRORS[INSTANCE_ERROR]);
            }

            if (!email && !instanceId) {
                this.helpers.error(INVALID_EMAIL);
                reject(this.instances[instanceId].config.messages["malformed"]);
            }

            if (!email && instanceId && !this.instances[instanceId].field) {
                this.helpers.error(INVALID_SELECTOR);
                reject(VERIFY_ERRORS[INVALID_SELECTOR]);
            }

            if (email && !instanceId && Object.keys(this.instances).length === 0) {
                this.helpers.error(INSTANCE_ERROR);
                reject(VERIFY_ERRORS[INSTANCE_ERROR]);
            }

            if (email && !instanceId && Object.keys(this.instances).length > 0) {
                instanceId = Object.keys(this.instances)[0];
            }

            const _email = instanceId ? (!email ? this.instances[instanceId].field.value : email) : email;

            this.validate(_email, instanceId).then((status) => {
                if (status) {
                    if (VERIFY_DEBUG)
                        console.debug("[VerifiedEmail] Local validation successful", {
                            email: _email,
                            instanceId
                        });
                    let recaptchaToken = "";
                    const remoteCall = () => {
                        new this.API(_email, recaptchaToken, this, instanceId, (vObj) => {
                            this.onVerified(vObj, instanceId)
                                .then(() => {
                                    if (instanceId && typeof this.instances[instanceId].field.setAttribute === "function") {
                                        this.instances[instanceId].field.setAttribute("data-status", (vObj || {}).result || "unknown");
                                        this.instances[instanceId].field.parentElement?.setAttribute(
                                            "data-status",
                                            (vObj || {}).result || "unknown"
                                        );
                                    }
                                    resolve(vObj || {});
                                })
                                .catch(() => {
                                    reject(VERIFY_ERRORS[FAILED_ERROR]);
                                });
                        });
                    };
                    if (recaptchaSiteKey) {
                        grecaptcha.enterprise.ready(async () => {
                            recaptchaToken = await grecaptcha.enterprise.execute(recaptchaSiteKey, { action: "verifications" });
                            remoteCall();
                        });
                    } else {
                        remoteCall();
                    }
                } else {
                    if (VERIFY_DEBUG)
                        console.debug("[VerifiedEmail] Local verification unsuccessful", {
                            email: _email,
                            instanceId
                        });
                    if (instanceId && typeof this.instances[instanceId].field.setAttribute === "function") {
                        this.instances[instanceId].field.setAttribute("data-status", "malformed");
                        this.instances[instanceId].field.parentElement?.setAttribute("data-status", "malformed");
                    }
                    reject(this.instances[instanceId].config.messages["malformed"]);
                }
            });
        });
    };

    this.onVerified = (vObj, instanceId = null) =>
        new Promise((resolve, reject) => {
            this.hookMap.onResponse(vObj || {}, instanceId).then(() => {
                const isValid = this.instances[instanceId].config.validStatuses.indexOf((vObj || {}).result || "") !== -1;
                if (isValid) {
                    this.hookMap.onSuccess(vObj || {}, instanceId).then(() => resolve(vObj || {}));
                } else {
                    reject(null);
                }
            });
        });
}

document.addEventListener("readystatechange", () => {
    if (document.readyState === "complete") {
        const script = Object.values(document.querySelectorAll("script")).find(
            (s) => (s.getAttribute("src") || "").indexOf("verified.email.min.js") > 0 && (s.getAttribute("src") || "").indexOf("token") > 0
        );
        if (script) {
            const url = new URL(script.getAttribute("src"));
            new VerifiedEmail(url.searchParams.get("token"), url.searchParams.get("recaptchaSiteKey"));

            if (typeof window[VERIFY_SETTINGS_VAR] !== "undefined") {
                window[VERIFY_INSTANCE].initialize(
                    document.querySelector(window[VERIFY_SETTINGS_VAR].selector),
                    window[VERIFY_SETTINGS_VAR]
                );
            } else {
                document.querySelectorAll("[data-verified-email]").forEach((item) => {
                    const _settings = {
                        live: !!item.getAttribute("verify-live") && item.getAttribute("verify-live") === "true",
                        submit: !!item.getAttribute("verify-submit") && item.getAttribute("verify-submit") === "true",
                        timeout: !!item.getAttribute("verify-timeout") && parseInt(item.getAttribute("verify-timeout")),
                        debounceDelay: !!item.getAttribute("verify-delay") && parseInt(item.getAttribute("verify-delay")),
                        valid:
                            !!item.getAttribute("verify-valid") &&
                            item
                                .getAttribute("verify-valid")
                                .split(",")
                                .map((s) => s.trim()),
                        callbacks: {}
                    };

                    Object.keys(_VE_EVENTS).map((callbackName) => {
                        if (item.getAttribute(callbackName)) {
                            const functionName = "callback" + window[VERIFY_INSTANCE].helpers.uuid().replace(/-/g, "");
                            const cmd = item.getAttribute(callbackName);
                            const script = document.createElement("script");
                            script.type = "text/javascript";
                            script.innerHTML = `function ${functionName}(event){ ${cmd} }`;
                            document.querySelector("head").appendChild(script);

                            _settings.callbacks[callbackName] = function (event) {
                                if (window[this.callback]) window[this.callback](event);
                            }.bind({ callback: functionName });
                        }
                    });

                    window[VERIFY_INSTANCE].initialize(item, _settings);
                });
            }

            // Assign verify functions
            Node.prototype.verify = function (e) {
                window[VERIFY_INSTANCE].verify(null, this.getAttribute("data-instance"));
            };

            if (typeof $ == "function") {
                $.fn.extend({
                    verify: function () {
                        window[VERIFY_INSTANCE].verify(null, $(this).attr("data-instance"));
                    }
                });
            } else if (typeof jQuery == "function") {
                jQuery.fn.extend({
                    verify: function () {
                        window[VERIFY_INSTANCE].verify(null, jQuery(this).attr("data-instance"));
                    }
                });
            }

            document.dispatchEvent(new CustomEvent(_VE_INITIALIZE_EVENT));
        } else console.warn("[VerifiedEmail] Unable to locate script tag with a valid token");
    }
});
